import React from 'react';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks/useForm';
import Event from '@/model/Event';
import Section from '@/model/Section';
import { Col, Form, FormGroup, Row } from 'reactstrap';
import { SelectCustom } from '@/components';
import { FormInputName } from '../../types';

interface StateProps {
  events: Event[];
  sections: Section[];
  formData: FormData;
  formErrors: FormErrors;
}

interface DispatchProps {
  onChangeFormInput: OnChangeFormInput;
  onGetSectionsByEvent: (eventId: string) => void;
}

type Props = StateProps & DispatchProps;

export const FilterContent: React.FC<Props> = ({
  events,
  sections,
  formData,
  formErrors,
  onChangeFormInput,
  onGetSectionsByEvent,
}) => {
  const eventOptions = events.map(event => ({
    label: event.name,
    value: event.id,
  }));

  const sectionOptions = sections.map(section => ({
    label: section.name,
    value: section.id,
  }));
  return (
    <div className="filter-modal-content">
      <span className="filter-name">Filtrar por:</span>
      <Form
        noValidate={true}
        onSubmit={(e): void => {
          e.preventDefault();
        }}
      >
        <Row>
          <Col md={8}>
            <FormGroup className="mb-2">
              <SelectCustom
                name="chargeSetupId"
                label="Evento"
                placeholder="..."
                value={formData[FormInputName.eventId]}
                onChange={e => {
                  onChangeFormInput(FormInputName.eventId)(e?.value as string);
                  onGetSectionsByEvent(e?.value as string);
                }}
                error={formErrors.eventId && formErrors.eventId[0]}
                options={eventOptions}
              />
            </FormGroup>
          </Col>
        </Row>
        {formData[FormInputName.eventId] && sections && sections.length > 0 && (
          <Row>
            <Col md={8}>
              <FormGroup className="mb-2">
                <SelectCustom
                  name="chargeSetupId"
                  label="Setor"
                  placeholder="..."
                  value={formData[FormInputName.sectionId]}
                  onChange={e => {
                    onChangeFormInput(FormInputName.sectionId)(e?.value as string);
                  }}
                  error={formErrors.sectionId && formErrors.sectionId[0]}
                  options={sectionOptions}
                />
              </FormGroup>
            </Col>
          </Row>
        )}
      </Form>
    </div>
  );
};
